<template>
  <div class="product-details-container">
    <div v-if="!isSuccess" class="content-main">
      <div class="product-content">
        <img class="product-img" :src="projectInfo.brandImg" alt="">
        <!-- <div class="welfare-info" v-if="scanType==='activityProduct'">限时福利：拍摄并上传<span class="tips">产品包装盒照片</span>，自动识别SN，成功绑定产品可获取<span class="tips">{{ activityInfo.rewardIntegral }}points/PCS</span></div> -->
        <div class="welfare-info" v-if="scanType==='activityProduct'">Limited-time Offer：Snap and upload a <span class="tips">photo of the product packaging</span>，The system will automatically identify the SN code. Successfully binding a product earns you <span class="tips">{{ activityInfo.rewardIntegral }} points/PCS</span></div>
        <div class="welfare-info" v-else>Upload sales receipt can get<span class="tips">{{ activityInfo.rewardIntegral }}points/PCS</span></div>
      </div>
      <Product v-if="scanType==='activityProduct'" :codeList="codeList" @checkoutCode="checkoutCode" :recognitionPrompt="recognitionPrompt" />
      <Upload ref="uploadRef" v-else />
      <div class="btn-content">
        <van-uploader v-show="scanType==='activityProduct' && codeList.length <= 0" :after-read="(files, detail) => afterRead(files, detail, 'imgCode')" ref="uploaderRef">
          <van-button type="warning" class="claim-btn">Upload Image</van-button>
        </van-uploader>
        <van-button v-show="codeList.length > 0" type="warning" class="claim-btn" @click="handleClaim">Claim Reward</van-button>
      </div>
    </div>
    <div class="last-confirm" v-else>
      <img v-if="successData.status === 10" class="success-img" src="@/assets/images/success_img.png" alt="">
      <img v-else-if="successData.status === -1" class="success-img" src="@/assets/images/fail_img.png" alt="">
      <img v-else class="success-img dong-img" src="@/assets/images/loading_img.png" alt="">
      <div v-if="successData.status === 10" class="success-desc">Approved，The reward will be credited to your account.：{{ successData.totalIntegral }} Point</div>
      <div v-else-if="successData.status === 0" class="success-desc">Recognizing...，The result will be available shortly，The page will refresh in {{ countdown }}s</div>
      <div v-else-if="successData.status === 1" class="success-desc">The PO document you uploaded requires a manual review. Thank you for your patience.</div>
      <div v-else-if="successData.status === -1" class="success-desc">This receipt has already been used. Please do not upload it again</div>
      <div class="confirm-btn" @click="handleSuccess">{{ successData.status === 10 ? 'Points Details' : [0, -1].includes(successData.status) ? 'View Details' :  successData.status === 1 ? 'Back to Event Home' : '' }}</div>
    </div>
  </div>
</template>

<script>
import { integralOrderApi, activityOrderReceiptOrderApi, activityOrderInfoApi, activityOrderSnOcrApi, activityOrderSnOcrResultApi } from '@/api'
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  name: 'ActivityProduct',
  components: {
    Product: () => import('./components/Product'),
    Upload: () => import('./components/Upload')
  },
  data () {
    return {
      barcode: '',
      codeList: [],
      isSuccess: false,
      successData: {},
      scanType: '',
      countdown: 15,
      imgCode: [],
      recognitionPrompt: false
    }
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo',
      activityInfo: 'activityInfo'
    })
  },
  created () {
    const { barcode, scanType } = this.$route.query
    this.barcode = barcode || ''
    this.scanType = scanType || ''
    // if (scanType === 'activityProduct') {
    //   this.checkoutCode(this.barcode)
    // }
  },
  methods: {
    handleClaim () {
      if (!this.checkedReward()) return
      const data = {
        // customerKey: this.userInfo.customerKey
        customerId: this.activityInfo.customerId,
        shareKey: this.activityInfo.shareKey
      }
      if (this.scanType === 'activityProduct') {
        data.snCodeList = this.codeList.map(subItem => subItem.code)
        data.imgUrl = this.codeList[0].imgUrl
      } else {
        const { imgUrl = [] } = this.$refs.uploadRef
        data.imgUrl = imgUrl.map(subItem => subItem.url).join(',')
      }
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      const requestApi = this.scanType === 'activityProduct' ? integralOrderApi : activityOrderReceiptOrderApi
      requestApi(data)
        .then((res) => {
          Toast.clear()
          this.isSuccess = true
          this.successData = res.data
          if (res.data.status === 0) {
            this.handleCountdown()
          }
        })
        .catch(() => {
          this.isSuccess = false
        })
    },
    checkoutCode (code) {
      this.$refs.uploaderRef.chooseFile()
      // Toast.loading({
      //   message: 'loading...',
      //   forbidClick: true,
      //   duration: 0
      // })
      // activityCheckoutCodeApi(code).then(res => {
      //   Toast.clear()
      //   let isAdd = true
      //   this.codeList.find(subItem => {
      //     if (subItem.code === code) {
      //       isAdd = false
      //       Toast('SN Used')
      //       return subItem
      //     }
      //   })
      //   if (isAdd) {
      //     this.codeList.push({ code, tips: res.data === 0 ? '' : res.data === 1 ? 'SN Used' : res.data === 2 ? 'Invalid SN' : 'Invalid SN', status: res.data })
      //   }
      // })
    },
    handleSuccess () {
      // this
      const { status, id } = this.successData
      if (status === 10) {
        this.$router.push(`/activity/pointsInfo?scanType=${this.scanType}`)
      } else if ([0, -1].includes(status)) {
        this.$router.push(`/activity/pointsDetail?scanType=${this.scanType}&scanId=${id}`)
      } else if (status === 1) {
        this.$router.push('/activity')
      }
    },
    checkedReward () {
      let isFlag = true
      if (this.scanType === 'activityProduct') {
        this.codeList.find(subItem => {
          if (subItem.tips) {
            Toast('Please delete invalid SN.')
            isFlag = false
            return subItem
          }
        })
        if (this.codeList.length <= 0) {
          Toast('Please scan the SN​ code to add product.')
          return false
        }
      } else {
        const { imgUrl } = this.$refs.uploadRef
        if (imgUrl.length <= 0) {
          Toast('Please Upload Image')
          return false
        }
      }
      return isFlag
    },
    getInfo () {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityOrderInfoApi(this.successData.id).then(res => {
        this.successData = res.data
        if (res.data.status === 0) {
          this.handleCountdown()
        }
        Toast.clear()
      })
    },
    // 状态为0开启倒计时
    handleCountdown () {
      this.countdown = 15
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown === 0) {
          clearImmediate(this.timer)
          this.getInfo()
        }
      }, 1000)
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this[key], detail.index, {
            url: res.url
          })
          Toast.loading({
            message: 'Identifying, please wait',
            forbidClick: true,
            duration: 0
          })
          activityOrderSnOcrApi({ imgUrl: res.url }).then(ocrRes => {
            this.getOcrReult(ocrRes.data, res.url)
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          Toast('Upload Failed')
          this.imgCode.splice(detail.index, 1)
          // this.imgUrl.splice()
          // console.log(files, detail, key)
        })
    },
    getOcrReult (key, imgUrl) {
      activityOrderSnOcrResultApi(key).then(res => {
        if (!res.data) {
          this.timerId = setInterval(() => {
            this.getOcrReult(key, imgUrl)
            clearInterval(this.timerId)
          }, 5000)
          return
        }
        clearInterval(this.timerId)
        const { code, items } = res.data
        Toast.clear()
        if ([0].includes(code)) {
          this.codeList = []
          if (items.length <= 0) {
            Toast('SN code not recognized')
            this.recognitionPrompt = true
          } else {
            this.recognitionPrompt = false
            items.forEach(subItem => {
              this.codeList.push({
                code: subItem.snCode,
                tips: subItem.error === 0 ? '' : subItem.error === 2 ? 'SN Used' : subItem.error === 1 ? 'Invalid SN' : 'Invalid SN',
                status: subItem.error,
                imgUrl: imgUrl
              })
            })
          }
        } else {
          Toast('SN code identification error.')
          this.recognitionPrompt = true
          this.codeList = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.product-details-container {
  padding: 20px;
  height: 100vh;
  font-size: 12px;
  .product-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 60px;
  }
  .content-main {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .product-img {
    width: 150px;
  }
  .welfare-info {
    font-size: 17px;
    margin-bottom: 22px;
    margin-top: 38px;
    .tips {
      font-size: 17px;
      color: #ee541b;
    }
  }
  .btn-content {
    height: 130px;
    text-align: center;
    .claim-btn {
      width: 166px;
      background-color: #ee541b;
      border-radius: 6px;
      border: none;
    }
    /deep/.van-button__text {
      font-size: 17px;
    }
  }
  .btn-content {
    margin-top: 10px;
  }
  .last-confirm {
    padding-top: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .success-img {
      width: 80px;
      height: 80px;
    }
    .success-desc {
      margin-top: 16px;
      margin-bottom: 36px;
      font-size: 14px;
    }
    .confirm-btn {
      width: 200px;
      height: 56px;
      text-align: center;
      line-height: 56px;
      font-size: 17px;
      font-weight: bold;
      color: #ee541b;
      border: 1px solid #ee541b;
      border-radius: 40px;
    }
  }
  .dong-img {
    display: block;
    transform-origin: center bottom;
    animation: pop3d 1s cubic-bezier(.25,.46,.45,.94) infinite;
    will-change: transform;
    backface-visibility: hidden
  }
  @keyframes pop3d {
    0%   { transform: translateZ(0)   scale(1)   rotateX(0deg); }
    40%  { transform: translateZ(80px) scale(1.2) rotateX(-8deg); } /* 冲到你面前+略俯视 */
    100% { transform: translateZ(0)   scale(1)   rotateX(0deg); }
  }
}
</style>
